const CommonSortTerms = {
  NEWEST_UPDATE: "updated_time_desc",
  OLDEST_UPDATE: "updated_time_asc",
};

export default CommonSortTerms;
